import React from "react";

const PrintIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
			<path
				d="M9 22C8.45 22 7.97917 21.8042 7.5875 21.4125C7.19583 21.0208 7 20.55 7 20V18H5C4.45 18 3.97917 17.8042 3.5875 17.4125C3.19583 17.0208 3 16.55 3 16V12C3 11.15 3.29167 10.4375 3.875 9.8625C4.45833 9.2875 5.16667 9 6 9H20C20.85 9 21.5625 9.2875 22.1375 9.8625C22.7125 10.4375 23 11.15 23 12V16C23 16.55 22.8042 17.0208 22.4125 17.4125C22.0208 17.8042 21.55 18 21 18H19V20C19 20.55 18.8042 21.0208 18.4125 21.4125C18.0208 21.8042 17.55 22 17 22H9ZM19 8H7V6C7 5.45 7.19583 4.97917 7.5875 4.5875C7.97917 4.19583 8.45 4 9 4H17C17.55 4 18.0208 4.19583 18.4125 4.5875C18.8042 4.97917 19 5.45 19 6V8ZM19 13.5C19.2833 13.5 19.5208 13.4042 19.7125 13.2125C19.9042 13.0208 20 12.7833 20 12.5C20 12.2167 19.9042 11.9792 19.7125 11.7875C19.5208 11.5958 19.2833 11.5 19 11.5C18.7167 11.5 18.4792 11.5958 18.2875 11.7875C18.0958 11.9792 18 12.2167 18 12.5C18 12.7833 18.0958 13.0208 18.2875 13.2125C18.4792 13.4042 18.7167 13.5 19 13.5ZM9 20H17V16H9V20Z"
				fill="#6B6C6D"
			/>
		</svg>
	);
};

export default PrintIcon;
